import request from '@/common/request'
export default {
  createAuditDemo: (dynaSeg, data, params) => {
    return request({
      url: '/auditDemo',
      method: 'post',
      data,
      params
    })
  },
  deleteAuditDemo: (dynaSeg, data, params) => {
    return request({
      url: `/auditDemo/${dynaSeg.id}`,
      method: 'delete',
      data,
      params
    })
  },
  updateAuditDemo: (dynaSeg, data, params) => {
    return request({
      url: `/auditDemo/${dynaSeg.id}`,
      method: 'put',
      data,
      params
    })
  },
  queryAuditDemo: params => {
    return request({
      url: '/auditDemo',
      method: 'get',
      params
    })
  },
  demoSubmitAudit: params => {
    return request({
      url: '/auditDemo/submit',
      method: 'get',
      params
    })
  },
  getDemoAuditDetail: params => {
    return request({
      url: '/auditDemo/getAuditDetail',
      method: 'get',
      params
    })
  },
  demoAuditEdit: data => {
    return request({
      url: '/auditDemo/auditEditSubmit',
      method: 'post',
      data
    })
  },
  getDemoAuditEditDetail : params => {
    return request({
      url: '/auditDemo/getAuditEditDetail',
      method: 'get',
      params
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/modules/auditDemo.js